module.exports = __webpack_public_path__ + "img/icon-up.c5434469.svg";